import { render, staticRenderFns } from "./VotebuttonTesstNew.vue?vue&type=template&id=6f424e8e&"
import script from "./VotebuttonTesstNew.vue?vue&type=script&lang=ts&"
export * from "./VotebuttonTesstNew.vue?vue&type=script&lang=ts&"
import style0 from "./VotebuttonTesstNew.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports